export const SET_PROFILE_STATE = 'profile/SET_STATE';
export const REQUEST_UPDATE_USER = 'profile/REQUEST_UPDATE_USER';
export const REQUEST_UPDATE_SETTINGS = 'profile/REQUEST_UPDATE_SETTINGS';
export const REQUEST_CONNECT_PROVIDER = 'profile/REQUEST_CONNECT_PROVIDER';
